module.exports = __webpack_public_path__ + "img/pay-step.ae041935.png";